'use client';

import { useState } from 'react';

interface FAQProps {
  question: string;
  answer: string;
}

export function FAQ({ question, answer }: FAQProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-gray-100 rounded-lg overflow-hidden mb-4 shadow-md hover:shadow-lg transition-shadow duration-200">
      <dt>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-left w-full flex justify-between items-center p-5 bg-white focus:outline-none"
        >
          <span className="text-lg font-medium text-gray-900">{question}</span>
          <span className="ml-6 flex-shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-gray-50 text-gray-500">
            <svg
              className={`${isOpen ? '-rotate-180' : 'rotate-0'} h-5 w-5 transform transition-transform duration-200 ease-in-out`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </span>
        </button>
      </dt>
      <dd className={`${isOpen ? 'block' : 'hidden'} border-t border-gray-100 px-5 py-5 bg-white`}>
        <p className="text-base text-gray-600">
          {answer}
        </p>
      </dd>
    </div>
  );
}
